// @generated by protoc-gen-es v1.10.1 with parameter "target=ts,import_extension=none"
// @generated from file mono/projectdata/v1/capture_team.proto (package mono.projectdata.v1, syntax proto3)
/* eslint-disable */ // @ts-nocheck
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { Message, proto3, Timestamp } from "@bufbuild/protobuf";
/**
 * @generated from message mono.projectdata.v1.CaptureTeamMemberView
 */ export class CaptureTeamMemberView extends Message {
    static fromBinary(bytes, options) {
        return new CaptureTeamMemberView().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CaptureTeamMemberView().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CaptureTeamMemberView().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CaptureTeamMemberView, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string capture_project_id = 2;
   */ _define_property(this, "captureProjectId", ""), /**
   * "account" | "named"
   *
   * @generated from field: string member_kind = 3;
   */ _define_property(this, "memberKind", ""), /**
   * Set iff member_kind == "account".
   *
   * @generated from field: string user_id = 4;
   */ _define_property(this, "userId", ""), /**
   * @generated from field: string display_name = 5;
   */ _define_property(this, "displayName", ""), /**
   * @generated from field: string role = 6;
   */ _define_property(this, "role", ""), /**
   * @generated from field: bool is_owner = 7;
   */ _define_property(this, "isOwner", false), /**
   * @generated from field: google.protobuf.Timestamp created_at = 8;
   */ _define_property(this, "createdAt", void 0), /**
   * @generated from field: google.protobuf.Timestamp updated_at = 9;
   */ _define_property(this, "updatedAt", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CaptureTeamMemberView, "runtime", proto3);
_define_property(CaptureTeamMemberView, "typeName", "mono.projectdata.v1.CaptureTeamMemberView");
_define_property(CaptureTeamMemberView, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "capture_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "member_kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "display_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "role",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "is_owner",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 8,
            name: "created_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 9,
            name: "updated_at",
            kind: "message",
            T: Timestamp
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ListCaptureTeamRequest
 */ export class ListCaptureTeamRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListCaptureTeamRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListCaptureTeamRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListCaptureTeamRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListCaptureTeamRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string capture_project_id = 1;
   */ _define_property(this, "captureProjectId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListCaptureTeamRequest, "runtime", proto3);
_define_property(ListCaptureTeamRequest, "typeName", "mono.projectdata.v1.ListCaptureTeamRequest");
_define_property(ListCaptureTeamRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "capture_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ListCaptureTeamResponse
 */ export class ListCaptureTeamResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListCaptureTeamResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListCaptureTeamResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListCaptureTeamResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListCaptureTeamResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.projectdata.v1.CaptureTeamMemberView members = 1;
   */ _define_property(this, "members", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListCaptureTeamResponse, "runtime", proto3);
_define_property(ListCaptureTeamResponse, "typeName", "mono.projectdata.v1.ListCaptureTeamResponse");
_define_property(ListCaptureTeamResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "members",
            kind: "message",
            T: CaptureTeamMemberView,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.AddNamedContributorRequest
 */ export class AddNamedContributorRequest extends Message {
    static fromBinary(bytes, options) {
        return new AddNamedContributorRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AddNamedContributorRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AddNamedContributorRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AddNamedContributorRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string capture_project_id = 1;
   */ _define_property(this, "captureProjectId", ""), /**
   * @generated from field: string display_name = 2;
   */ _define_property(this, "displayName", ""), /**
   * @generated from field: string role = 3;
   */ _define_property(this, "role", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(AddNamedContributorRequest, "runtime", proto3);
_define_property(AddNamedContributorRequest, "typeName", "mono.projectdata.v1.AddNamedContributorRequest");
_define_property(AddNamedContributorRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "capture_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "display_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "role",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.AddNamedContributorResponse
 */ export class AddNamedContributorResponse extends Message {
    static fromBinary(bytes, options) {
        return new AddNamedContributorResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AddNamedContributorResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AddNamedContributorResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AddNamedContributorResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.projectdata.v1.CaptureTeamMemberView member = 1;
   */ _define_property(this, "member", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(AddNamedContributorResponse, "runtime", proto3);
_define_property(AddNamedContributorResponse, "typeName", "mono.projectdata.v1.AddNamedContributorResponse");
_define_property(AddNamedContributorResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "member",
            kind: "message",
            T: CaptureTeamMemberView
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.AddAccountMemberRequest
 */ export class AddAccountMemberRequest extends Message {
    static fromBinary(bytes, options) {
        return new AddAccountMemberRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AddAccountMemberRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AddAccountMemberRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AddAccountMemberRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string capture_project_id = 1;
   */ _define_property(this, "captureProjectId", ""), /**
   * @generated from field: string user_id = 2;
   */ _define_property(this, "userId", ""), /**
   * @generated from field: string role = 3;
   */ _define_property(this, "role", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(AddAccountMemberRequest, "runtime", proto3);
_define_property(AddAccountMemberRequest, "typeName", "mono.projectdata.v1.AddAccountMemberRequest");
_define_property(AddAccountMemberRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "capture_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "role",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.AddAccountMemberResponse
 */ export class AddAccountMemberResponse extends Message {
    static fromBinary(bytes, options) {
        return new AddAccountMemberResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AddAccountMemberResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AddAccountMemberResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AddAccountMemberResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.projectdata.v1.CaptureTeamMemberView member = 1;
   */ _define_property(this, "member", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(AddAccountMemberResponse, "runtime", proto3);
_define_property(AddAccountMemberResponse, "typeName", "mono.projectdata.v1.AddAccountMemberResponse");
_define_property(AddAccountMemberResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "member",
            kind: "message",
            T: CaptureTeamMemberView
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.RemoveCaptureTeamMemberRequest
 */ export class RemoveCaptureTeamMemberRequest extends Message {
    static fromBinary(bytes, options) {
        return new RemoveCaptureTeamMemberRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RemoveCaptureTeamMemberRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RemoveCaptureTeamMemberRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RemoveCaptureTeamMemberRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string capture_project_id = 1;
   */ _define_property(this, "captureProjectId", ""), /**
   * @generated from field: string member_id = 2;
   */ _define_property(this, "memberId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(RemoveCaptureTeamMemberRequest, "runtime", proto3);
_define_property(RemoveCaptureTeamMemberRequest, "typeName", "mono.projectdata.v1.RemoveCaptureTeamMemberRequest");
_define_property(RemoveCaptureTeamMemberRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "capture_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "member_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.RemoveCaptureTeamMemberResponse
 */ export class RemoveCaptureTeamMemberResponse extends Message {
    static fromBinary(bytes, options) {
        return new RemoveCaptureTeamMemberResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RemoveCaptureTeamMemberResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RemoveCaptureTeamMemberResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RemoveCaptureTeamMemberResponse, a, b);
    }
    constructor(data){
        super();
        proto3.util.initPartial(data, this);
    }
}
_define_property(RemoveCaptureTeamMemberResponse, "runtime", proto3);
_define_property(RemoveCaptureTeamMemberResponse, "typeName", "mono.projectdata.v1.RemoveCaptureTeamMemberResponse");
_define_property(RemoveCaptureTeamMemberResponse, "fields", proto3.util.newFieldList(()=>[]));
/**
 * @generated from message mono.projectdata.v1.SetCaptureTeamOwnerRequest
 */ export class SetCaptureTeamOwnerRequest extends Message {
    static fromBinary(bytes, options) {
        return new SetCaptureTeamOwnerRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SetCaptureTeamOwnerRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SetCaptureTeamOwnerRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SetCaptureTeamOwnerRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string capture_project_id = 1;
   */ _define_property(this, "captureProjectId", ""), /**
   * @generated from field: string user_id = 2;
   */ _define_property(this, "userId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(SetCaptureTeamOwnerRequest, "runtime", proto3);
_define_property(SetCaptureTeamOwnerRequest, "typeName", "mono.projectdata.v1.SetCaptureTeamOwnerRequest");
_define_property(SetCaptureTeamOwnerRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "capture_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.SetCaptureTeamOwnerResponse
 */ export class SetCaptureTeamOwnerResponse extends Message {
    static fromBinary(bytes, options) {
        return new SetCaptureTeamOwnerResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SetCaptureTeamOwnerResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SetCaptureTeamOwnerResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SetCaptureTeamOwnerResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.projectdata.v1.CaptureTeamMemberView owner = 1;
   */ _define_property(this, "owner", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(SetCaptureTeamOwnerResponse, "runtime", proto3);
_define_property(SetCaptureTeamOwnerResponse, "typeName", "mono.projectdata.v1.SetCaptureTeamOwnerResponse");
_define_property(SetCaptureTeamOwnerResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "owner",
            kind: "message",
            T: CaptureTeamMemberView
        }
    ]));
